import { h } from 'preact';
import cn from 'classnames';

const Spinner = ({ isVisible = false }) => (
  <div class={cn('as-Spinner', { 'is-visible': isVisible })}>
    <shore-spinner />
  </div>
);

export default Spinner;
